module.exports = __webpack_public_path__ + "static/media/tree-christmas.961d8b8e.svg";